import { Link } from "react-router-dom";
import Breadcrumb from "../components/BreadCurmb";
import FooterOne from "../footer/FooterOne";
import HeaderOne from "../header/HeaderOne";

export default function TeamDetails(){
	return(
		<>
			<HeaderOne/>
			<Breadcrumb subtitle={"Responsive & functional IT design"} title={"Team Details"} pagetitle={"Single Team"}/>
				<section className="team-details-area pt-115 pb-90 pt-md-60 pt-xs-60 pb-md-30 pb-xs-30">
					<div className="container">
						<div
							className="row team-bot-border align-items-center pb-70 mb-100 mb-md-60 mb-xs-60 pb-md-20 pb-xs-20 mb-xs-60">
							<div className="col-lg-6 col-md-12">
								<div className="team-img mb-30">
									<img className=" d-none d-lg-block w-100 border-img" src="assets/img/team/team-9.jpg" alt="img" />
									<img className="d-md-block d-lg-none w-100 border-img" src="assets/img/team/team-9a.jpg" alt="img" />
								</div>
							</div>
							<div className="col-lg-6 col-md-12">
								<div className="team-details-wrapper pl-50 mb-30 pl-md-0 pl-xs-0">
									<p className="fs-14 lh-1 mb-15">Founder</p>
									<h2 className="sect-title lh-1 mb-20">Hexol D. Drownix</h2>
									<p>The spectacular Harbour Central is a brand new development in London’s The Docklands,
										comprising a total of 642 private apartments divided across five residential buildings,
										along with a leisure complex.</p>
									<div className="adress-box mt-25">
										<div className="icon-link">
											<i className="fas fa-phone"></i>
										</div>
										<div className="address-content">
											<p className="fs-14">Phone Number</p>
											<h5 className="fs-20">+(908) 786 789 78 6</h5>
										</div>
									</div>
									<div className="adress-box">
										<div className="icon-link">
											<i className="fas fa-envelope"></i>
										</div>
										<div className="address-content">
											<p className="fs-14">Email Address</p>
											<h5 className="fs-20">info@webexample.com</h5>
										</div>
									</div>
									<div className="adress-box pb-20">
										<div className="icon-link">
											<i className="fas fa-map-marker-alt"></i>
										</div>
										<div className="address-content">
											<p className="fs-14">Office Location</p>
											<h5 className="fs-20">14/A, Kilix Home Tower, NYC</h5>
										</div>
									</div>
									<Link to="/contact" className="theme_btn theme_btn3">Get In Touch <i
											className="fal fa-long-arrow-right"></i></Link>
								</div>
							</div>
						</div>
						<div className="row team-bot-border align-items-center pb-70 mb-100 mb-md-60 pb-md-30 pb-xs-25 mb-xs-60">
							<div className="col-lg-6 col-md-12 order-last order-lg-first">
								<div className="team-skill-wrapper overflow-hidden pr-100 mb-30">
									<h3 className="teams-title">Personal Skills</h3>
									<div className="comic-progress-bar mb-35">
										<h5 className="p-title">Product Design</h5>
										<div className="progress">
											<div className="progress-bar wow slideInLeft animated" data-wow-delay="0.1s"
												role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100">
												<span>70%</span>
											</div>
										</div>
									</div>
									<div className="comic-progress-bar bar-2 mb-35">
										<h5 className="p-title">Design & Development Support</h5>
										<div className="progress">
											<div className="progress-bar wow slideInLeft animated" data-wow-delay="0.1s"
												role="progressbar" aria-valuenow="52" aria-valuemin="0" aria-valuemax="100">
												<span>52%</span>
											</div>
										</div>
									</div>
									<div className="comic-progress-bar bar-3">
										<h5 className="p-title">User Experience & Research</h5>
										<div className="progress">
											<div className="progress-bar wow slideInLeft animated" data-wow-delay="0.1s"
												role="progressbar" aria-valuenow="82" aria-valuemin="0" aria-valuemax="100">
												<span>82%</span>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="col-lg-6 col-md-12">
								<div className="team-img mb-30">
									<img className="w-100 border-img" src="assets/img/team/team-10.jpg" alt="img" />
								</div>
							</div>
						</div>
						<div className="row align-items-center">
							<div className="col-lg-6 col-md-12">
								<div className="team-img mb-30">
									<img className="w-100 border-img" src="assets/img/team/team-11.jpg" alt="img" />
								</div>
							</div>
							<div className="col-lg-6 col-md-12">
								<div className="career-guide-wrapper pl-40 pe-xxl-5 mb-30 pl-md-0 pl-xs-0">
									<h3 className="teams-title lh-1 mb-30">Great Archivements</h3>
									<p className="mb-35">Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
										Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris ni
										ut aliquip ex ea commodo consequat. Duis aute irure dolor in repreh
										derit in voluptate velit esse cillum dolor.</p>
									<ul className="certifacate-list d-sm-flex align-items-center">
										<li><img src="assets/img/team/certificate-1.jpg" alt="Img" /></li>
										<li><img src="assets/img/team/certificate-2.jpg" alt="Img" /></li>
										<li><img src="assets/img/team/certificate-3.jpg" alt="Img" /></li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</section>
			<FooterOne/>
		</>
	)
}